export default "__VITE_ASSET__kCC6qrbK__"